var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"owc-wb-accordion-item"},[_c('SlotContainer',{attrs:{"refName":"slot-accordion-content","wrapperClass":"owc-wb-accordion-content","slot-component-data":JSON.stringify({ isPartOfAccordion: true })}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }